import { render, staticRenderFns } from "./AddEventForm.vue?vue&type=template&id=df233078&scoped=true&"
import script from "./js/add-event-form.js?vue&type=script&lang=js&"
export * from "./js/add-event-form.js?vue&type=script&lang=js&"
import style0 from "./AddEventForm.vue?vue&type=style&index=0&id=df233078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df233078",
  null
  
)

export default component.exports